import { captureException } from "@sentry/react-native";
import { SafeAreaView } from "react-native";
import WebView, { WebViewMessageEvent } from "react-native-webview";
import { useTailwind } from "tailwind-rn";

import useDeliveryFulfillments from "../../contexts/DeliveryFulfillmentsContext";
import {
  deliveryFulfillmentsRoutes,
  DeliveryFulfillmentsScreenProps,
} from "../../navigation/types";
import { LatLng } from "../../types";

type Props = DeliveryFulfillmentsScreenProps<
  typeof deliveryFulfillmentsRoutes.map
>;

export default function MapScreen({ navigation }: Props) {
  const tailwind = useTailwind();

  const { setSelectedMapData } = useDeliveryFulfillments();

  function onMessage(event: WebViewMessageEvent) {
    try {
      const msg = JSON.parse(event.nativeEvent.data);
      if (msg.type === "position") {
        const position = msg.position as LatLng;
        const text = msg.text as string;
        setSelectedMapData({ position, text });
        navigation.navigate(deliveryFulfillmentsRoutes.pickupLocation);
      }
    } catch (e) {
      captureException(e);
    }
  }

  return (
    <SafeAreaView style={tailwind("flex-1")}>
      <WebView
        source={{ uri: "https://checkout-staging.cuanto.app/map" }}
        geolocationEnabled
        scrollEnabled={false}
        onMessage={onMessage}
        onNavigationStateChange={(e) => {
          const isShowingMap = e.url.includes("/map/map");
          navigation.setOptions({ headerShown: !isShowingMap });
          console.log({ isShowingMap, url: e.url });
        }}
      />
    </SafeAreaView>
  );
}
